import React, { useState } from 'react';
import { CheckCircle2, Circle, X } from 'lucide-react';

const KEY = 'sleekHearGettingStartedHidden';

const readHidden = () => {
  try { return localStorage.getItem(KEY) === 'true'; } catch { return false; }
};

/**
 * A short first-run checklist on the Bible view. Each step ticks itself when it
 * has been done, and the whole card can be hidden for good.
 * `steps` = [{ label, hint, done }].
 */
const GettingStarted = ({ steps, dm, t }) => {
  const [hidden, setHidden] = useState(readHidden);
  if (hidden) return null;

  const doneCount = steps.filter(s => s.done).length;
  const allDone = doneCount === steps.length;
  const hide = () => {
    try { localStorage.setItem(KEY, 'true'); } catch { /* it just comes back next time */ }
    setHidden(true);
  };

  return (
    <section
      aria-label="Getting started"
      className={`mb-3 p-3 rounded-lg border ${dm ? 'bg-emerald-900/20 border-emerald-500/30' : 'bg-emerald-50 border-emerald-200'}`}
    >
      <div className="flex items-center justify-between mb-2">
        <h3 className={`text-sm font-bold ${dm ? 'text-emerald-300' : 'text-emerald-700'}`}>
          {allDone ? "You're all set" : `Getting started · ${doneCount} of ${steps.length}`}
        </h3>
        <button onClick={hide} aria-label="Hide getting started" title="Hide this" className={`p-1 rounded ${t.dropdownItem}`}>
          <X className="w-4 h-4" />
        </button>
      </div>
      <ol className="space-y-2">
        {steps.map(step => (
          <li key={step.label} className="flex items-start gap-2">
            {step.done
              ? <CheckCircle2 className="w-5 h-5 shrink-0 text-emerald-400" aria-label="Done" />
              : <Circle className={`w-5 h-5 shrink-0 ${t.textMuted}`} aria-label="Not done yet" />}
            <div>
              <div className={`text-sm font-semibold ${step.done ? t.textSecondary : t.textPrimary} ${step.done ? 'line-through' : ''}`}>{step.label}</div>
              {!step.done && <div className={`text-xs ${t.textSecondary}`}>{step.hint}</div>}
            </div>
          </li>
        ))}
      </ol>
      {allDone && (
        <button onClick={hide} className="mt-3 px-3 py-1.5 rounded-lg text-xs font-semibold bg-emerald-600 text-white hover:bg-emerald-500">
          Hide this
        </button>
      )}
    </section>
  );
};

export default GettingStarted;
